import {
  renderSvelteComponent,
  findElementInShadowDom,
  findAllElementsInShadowDom,
} from './utils/render.js';

import CardGrid from './components/ExpandableCardGrid.svelte';

async function main() {
  // Find grid and render component
  let cardGridEl = findElementInShadowDom('#group-3');
  if (cardGridEl) {
    // Get data from DOM elements
    let cards = cardGridEl.querySelectorAll('.card');
    let cardData = Array.from(cards).map((card) => {
      let data = Object.assign({}, card.dataset);
      let titleEl = card.querySelector('.card__title');
      let lossEl = card.querySelector('.card__loss');
      let bodyEl = card.querySelector('.card__body');
      let altTextEl = card.querySelector('.card__alt-text');

      data['title'] = titleEl?.innerHTML;
      data['loss'] = lossEl?.innerHTML;
      data['body'] = bodyEl?.innerHTML;
      data['altText'] = altTextEl?.innerHTML;

      return data;
    });

    // Clear out the grid
    cardGridEl.innerHTML = '';

    // Render component
    renderSvelteComponent(CardGrid, cardGridEl, {
      cards: cardData,
    });
  }
}
main().catch(console.error);
